export function formatViews(views: number): string {
  if (views >= 100000000) return `${(views / 100000000).toFixed(1)}亿`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}

export function formatDate(date: string): string {
  if (!date) return '';
  const [y, m, d] = date.split('-');
  if (!y || !m || !d) return date;
  return `${y}-${m}-${d}`;
}

export function relativeUpdate(date: string): string {
  if (!date) return '';
  const target = new Date(date).getTime();
  const now = Date.now();
  const diffDays = Math.floor((now - target) / (1000 * 60 * 60 * 24));
  if (diffDays <= 0) return '今日更新';
  if (diffDays === 1) return '昨日更新';
  if (diffDays < 7) return `${diffDays}天前更新`;
  return formatDate(date);
}